import base from './base';
import { Ienvironment } from './ienvironment';

export const environment: Ienvironment = {
  ...base,
  production: true,
  appId: '71876276-002d-4286-981b-bc5ec4b3d640',
  invoiceServiceApiBaseUrl: 'https://invoiceservice.allinoneinvoice.com',
  communicationserviceApiBaseUrl: 'https://communicationservice.allinoneinvoice.com',
  authServiceApiBaseUrl: 'https://authservice.allinoneinvoice.com',
  userServiceApiBaseUrl: 'https://userservice.allinoneinvoice.com',
};
